import { useId, type SVGProps } from "react";

export const Smena = (props: SVGProps<SVGSVGElement>) => {
  const clipPathIdFirst = useId();
  const clipPathIdSecond = useId();

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath={`url(#${clipPathIdFirst})`}>
        <rect width="40" height="40" rx="12" fill="#fff" />
        <g clipPath={`url(#${clipPathIdSecond})`}>
          <path d="M0 0h40v40H0V0Z" fill="#F2EEE2" />
          <path
            fill="#FF6C02"
            d="M12.656 0H40v27.344H12.656zM0 27.344h12.656V40H0z"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathIdFirst}>
          <rect width="40" height="40" rx="12" fill="#fff" />
        </clipPath>
        <clipPath id={clipPathIdSecond}>
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
